import React from "react";

import styles from "./HomeHeader.module.scss";

import WeatherlyLogo from "../2_molecules/WeatherlyLogo";

function HomeHeader() {
  return (
    <header className={styles["container"]}>
      <WeatherlyLogo />
    </header>
  );
}

export default React.memo(HomeHeader);
